









































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import AcademicArea from '../../../models/academic/academicArea.model';

@Component
export default class AcademicAreaAdd extends GenericAdd<AcademicArea> {
  constructor() {
    super();
    this.controller = "AcademicArea";
    this.model = new AcademicArea();
  }
}
